import React, { useState, useMemo, useEffect, useContext } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useNavigate } from 'react-router-dom';

import { Modal } from 'antd';
import { UpdateCalendarContext } from 'Contexts';
import moment from 'moment';

//Spin
import styled from 'styled-components';

import { eventPropGetter, modelCalendarParseEvents } from '@libs/Calendar';
import { isJobEvent } from '@libs/EventTypes';
import { getMoment } from '@libs/NwMoment';

import { UserContext } from '@contexts/UserContext';
import { useUserGuiConfig } from '@contexts/UserGuiConfigContext';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import AddFastPackageButton from '@components/ActivePackages/AddFastPackageButton';
import { BookSelectorButton } from '@components/BookSelectorForPackages';
import ContactAvatar from '@components/ContactAvatarGroup/ContactAvatar';
import ModelDrawer from '@components/ContactDetails/ModelDetails/Drawer/ModelDrawer';
import EventDrawer from '@components/EventDrawer/EventDrawer';
import NwIcon from '@components/Gui/NwIcon';
import BookingCalendarHeader from '@components/Schedule/Calendar/BookingCalendarHeader';
import CalendarDateHeader from '@components/Schedule/Calendar/CalendarDateHeader';
import CalendarWrapper from '@components/Schedule/Calendar/CalendarUI';
import DailyCalendarDrawer from '@components/Schedule/Calendar/DailyCalendarDrawer';
import EventCard from '@components/Schedule/Calendar/EventCard';
// import dayRenderAlgorithm from '@components/Schedule/Calendar/GeneralCalendar/DayRenderAlgorithm';
// import ModelCalendarHeader from '@components/Schedule/Calendar/ModelCalendarHeader';
import { getAgendaDefaultDate, getCalendarDefaultDate, getScheduleEvents } from '@components/Schedule/ScheduleUtils';

import MonthEventCard from '../MonthEventCard';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ModelBigCalendar = Calendar;

//const localizer = momentLocalizer(moment);
moment.tz.setDefault('UTC');
const localizer = momentLocalizer(moment);
localizer.segmentOffset = 0;

// const CalendarView = styled.div`
//     position: relative;

//     .ant-spin {
//         max-height: unset !important;
//     }
// `;

// const StyledAlert = styled(Alert)`
//     position: absolute;
//     z-index: 20;
//     top: 40%;
//     left: 50%;
//     box-shadow: 0px 6px 16px rgb(0 0 0 / 12%);
//     transform: translate(-50%, -50%);

//     .ant-alert-message {
//         margin-right: 8px;
//     }
// `;

const StyledModal = styled(Modal)`
    .ant-modal-header {
        border-bottom: none;
        padding-bottom: 0;
    }

    .multi-event-modal-container {
        ul > li {
            font-weight: bold;
        }

        .multi-event-modal-buttons {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            min-height: 5rem;
        }
    }
`;

const CalendarBefore = styled.div`
    padding-left: 1rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    position: sticky;
    top: 4rem;
    background-color: white;
    z-index: 1000;

    .calendar-before-back {
        font-size: 2rem;
        border-right: ${(props) => props.theme.DefaultBorder};
        padding: 0 1rem 0 0.25rem;
    }

    .calendar-before-avatar {
        cursor: pointer;
    }

    .calendar-before-name {
        min-width: 9rem;
        h3 {
            font-size: 1.4rem;
            line-height: 1em;
            font-weight: 500;
            margin: 0 0 1rem 0;
            text-transform: capitalize;
            cursor: pointer;
        }
    }
    .calendar-before-icons {
        margin-left: 1.75rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        vertical-align: middle;
        gap: 1.5rem;
        font-size: 1.5rem;

        .ant-badge {
            font-size: 1.5rem;
        }
    }
`;

const ModelCalendar = ({
    afterReload,
    bookingSection,
    calendarStyle,
    contactId,
    filters,
    onCreateEvent,
    onClearContactID,
    onOpenSendAgendaDrawer,
    onOpenAvailableEventsDrawer,
    onReload,
    onScheduleRangeChange,
    params,
    previewMode,
    reload,
    scheduleRange,
}) => {
    const navigate = useNavigate();

    const [selectedEvent, setSelectedEvent] = useState();
    const [showEventDrawer, setShowEventDrawer] = useState(false);

    // const [defaultEventDate, setDefaultEventDate] = useState();
    // const [allDay, setAllDay] = useState(false);

    const [calendarEvents, setCalendarEvents] = useState([]);

    // const [isEventDrawer, setIsEventDrawer] = useState(false);
    // const [eventType, setEventType] = useState();

    const userGuiConfig = useUserGuiConfig();
    const { currentUser } = useContext(UserContext);

    const breakpoints = useNwBreakPoints();
    const [expanded, setExpanded] = useState(true);
    const [errorModal, setErrorModal] = useState('');

    // const [isFetching, setIsFetching] = useState(false);

    const [modelDetailsDrawerID, setModelDetailsDrawerID] = useState(null);

    const [dayViewDate, setDayViewDate] = useState(false);

    const updateCalendarContext = useContext(UpdateCalendarContext);

    const mixedEventsChart = userGuiConfig && userGuiConfig.schedule && userGuiConfig.schedule.mixedEventsChart;

    moment.locale('us', {
        week: {
            dow: 1,
            doy: 1,
        },
    });

    useEffect(() => {
        if (scheduleRange || updateCalendarContext.updateCalendar) {
            fetchEvents();
            if (updateCalendarContext.updateCalendar) {
                updateCalendarContext.setUpdateCalendar(false);
            }
        }
    }, [params, scheduleRange, updateCalendarContext.updateCalendar]);

    useEffect(() => {
        if (scheduleRange && reload) {
            fetchEvents();
        }
    }, [reload]);

    const fetchEvents = async () => {
        // setIsFetching(true);
        const scheduleEvents = await getScheduleEvents(params, scheduleRange);
        setCalendarEvents(modelCalendarParseEvents(scheduleEvents, mixedEventsChart));
        // setIsFetching(false);
        afterReload();
    };

    const reloadCalendar = () => {
        fetchEvents();
    };

    const onSelectEvent = (event) => {
        if (event.ID && event.elType !== 'Package' && !previewMode) {
            setShowEventDrawer(true);
            setSelectedEvent(event);
        }
    };

    const handleCloseEventDrawer = () => {
        reloadCalendar();
        setShowEventDrawer(false);
        setSelectedEvent(null);
    };

    const handleCloseEventDrawerNoReload = () => {
        setShowEventDrawer(false);
        setSelectedEvent(null);
    };

    const afterRemoveEvents = () => {
        setShowEventDrawer(false);
        setSelectedEvent(null);
        reloadCalendar();
    };

    const handleRangeChange = (event) => {
        if (event.start && event.end) {
            onScheduleRangeChange(event.start, event.end);
        } else {
            onScheduleRangeChange(event[0], event[event.length - 1]);
        }
    };

    const filteredEvents = useMemo(() => {
        let filteredEvents = [...calendarEvents];
        if (filters) {
            if (filters.filterAcknowledgement === 'checked') {
                filteredEvents = filteredEvents.filter((event) => event.Acknowledgment === 'Checked');
            } else if (filters.filterAcknowledgement === 'tocheck') {
                filteredEvents = filteredEvents.filter((event) => event.Acknowledgment === 'NotChecked');
            }
            if (filters.filterMine === 'mine') {
                //filteredEvents = filteredEvents.filter(event => event.UserCreated === currentUser.UserID);
                filteredEvents = filteredEvents.filter(
                    (event) =>
                        event.UserCreated === currentUser.UserID ||
                        (event.Project && event.Project.UserCreated === currentUser.UserID)
                );
            }
            if (filters.hideCancelled) {
                filteredEvents = filteredEvents.filter((event) => !event.Cancel);
            }
            if (filters.hideBilling) {
                filteredEvents = filteredEvents.filter(
                    (event) => !event.Locked && isJobEvent(event.TypeName) && event.Confirmed > 0
                );
            }
        }
        return filteredEvents;
    }, [calendarEvents, filters]);

    useEffect(() => {
        const isInvisibleEvent = filteredEvents.find(
            (event) => (getMoment(event.start).hour() < 6 || getMoment(event.end).hour() >= 22) && !event.allDay
        );
        if (isInvisibleEvent && !expanded) {
            setExpanded(true);
        }
    }, [filteredEvents]);

    const switchToAgenda = () => {
        const agendaSelectedDate = getAgendaDefaultDate(scheduleRange);
        onScheduleRangeChange(agendaSelectedDate.toDate(), agendaSelectedDate.toDate());
    };

    const getDailyDrawerScheduleRange = () => {
        return { start: dayViewDate, end: dayViewDate };
    };

    const getCalendarHeader = (toolbar) => {
        // if (bookingSection) {
        return (
            <BookingCalendarHeader
                calendarStyle={calendarStyle}
                model
                onSwitchToAgenda={switchToAgenda}
                params={params}
                previewMode={previewMode}
                toolbar={toolbar}
            />
        );
        // } else {
        //     return (
        //         <ModelCalendarHeader
        //             calendarStyle={calendarStyle}
        //             onSwitchToAgenda={switchToAgenda}
        //             previewMode={previewMode}
        //             toolbar={toolbar}
        //         />
        //     );
        // }
    };

    const openModelDrawer = () => {
        setModelDetailsDrawerID(contactId);
    };

    const goToModelPage = () => {
        navigate(`/model/${contactId}`);
    };

    return (
        <CalendarWrapper
            showTimeGrid={false}
            breakpoints={breakpoints}
            agendaWeeklyView={!expanded && calendarStyle === 'week'}
            minHeight={bookingSection ? null : 'calc(100vh - 25rem)'}
            bookingSection={bookingSection}
        >
            <div className={`general-calendar model-calendar ${mixedEventsChart ? 'mixed-events-chart' : ''}`}>
                <div className={`calendar${calendarStyle === 'week' ? ' calendar-custom-week' : ''}`}>
                    <CalendarBefore className="calendar-before">
                        <div className="calendar-before-back">
                            <NwIcon
                                pointer
                                icon={byPrefixAndName.fasl['arrow-left-to-line']}
                                onClick={onClearContactID}
                            />
                        </div>
                        <div className="calendar-before-avatar">
                            <ContactAvatar onClick={goToModelPage} contactID={contactId} />
                        </div>
                        <div className="calendar-before-name">
                            <h3 onClick={goToModelPage}>{getContactName(contactId).toLowerCase()}</h3>
                        </div>
                        <div className="calendar-before-icons">
                            <NwIcon
                                size="lg"
                                pointer
                                icon={byPrefixAndName.fasl['sidebar-flip']}
                                onClick={openModelDrawer}
                            />
                            <BookSelectorButton modelID={contactId} />
                            <AddFastPackageButton modelID={contactId} />
                        </div>
                    </CalendarBefore>
                    {scheduleRange && scheduleRange.start && scheduleRange.end ? (
                        <ModelBigCalendar
                            selectable="ignoreEvents"
                            localizer={localizer}
                            formats={{
                                timeGutterFormat: userGuiConfig.calendar.timeFormat === '24' ? 'H:mm' : 'h:mm a',
                            }}
                            defaultDate={getCalendarDefaultDate(scheduleRange).toDate()}
                            views={{ week: true, month: true }}
                            // defaultView={calendarStyle}
                            defaultView={Views.WEEK}
                            eventPropGetter={eventPropGetter}
                            view={calendarStyle} //non c'era
                            components={{
                                event: (event) => {
                                    if (calendarStyle === 'month') {
                                        return (
                                            <EventCard event={event.event} model modelNoTimeGrid monthView agendaView />
                                        );
                                    } else {
                                        return <EventCard event={event.event} model modelNoTimeGrid agendaView />;
                                    }
                                },
                                toolbar: (toolbar) => (
                                    <BookingCalendarHeader
                                        calendarStyle={calendarStyle}
                                        model
                                        onSwitchToAgenda={switchToAgenda}
                                        params={params}
                                        previewMode={previewMode}
                                        toolbar={toolbar}
                                    />
                                ),
                                week: {
                                    header: (date) => (
                                        <CalendarDateHeader
                                            date={date}
                                            modelID={contactId}
                                            modellist={[]}
                                            onCreateEvent={onCreateEvent}
                                            onReload={onReload}
                                            onSendAgendaIconClick={onOpenSendAgendaDrawer}
                                            onOpenAvailableEventsDrawer={onOpenAvailableEventsDrawer}
                                            onDateClick={setDayViewDate}
                                        />
                                    ),
                                },
                                month: {
                                    dateHeader: (date) => (
                                        <CalendarDateHeader
                                            month
                                            date={date}
                                            modelID={contactId}
                                            modellist={[]}
                                            onCreateEvent={onCreateEvent}
                                            onReload={onReload}
                                            onSendAgendaIconClick={onOpenSendAgendaDrawer}
                                            onDateClick={setDayViewDate}
                                            onOpenAvailableEventsDrawer={onOpenAvailableEventsDrawer}
                                        />
                                    ),
                                },
                            }}
                            allDayAccessor={(event) => {
                                return event.onAllDaySection;
                            }}
                            tooltipAccessor={null}
                            onSelectEvent={onSelectEvent}
                            onRangeChange={handleRangeChange}
                            // onDrillDown={value => {
                            //     setDayViewDate(value)
                            // }}
                            // popup - non era commentato
                            showAllEvents
                            drilldownView={null}
                            events={filteredEvents}
                            //scrollToTime={getMoment(startDate).toDate()}
                            // step={30} - non era commentato
                            // timeslots={2} - non era commentato
                        />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            {dayViewDate && (
                <DailyCalendarDrawer
                    params={params}
                    filters={filters}
                    scheduleRange={getDailyDrawerScheduleRange()}
                    onClose={() => setDayViewDate(null)}
                />
            )}
            {showEventDrawer && selectedEvent && (
                <EventDrawer
                    eventType={selectedEvent.TypeName}
                    eventID={selectedEvent.ID}
                    modelId={contactId}
                    eventObject={selectedEvent}
                    onCloseNoReload={handleCloseEventDrawerNoReload}
                    onClose={handleCloseEventDrawer}
                    afterUpdate={() => {
                        //moved to onClose
                        //fetchEvents()
                    }}
                    afterRemove={afterRemoveEvents}
                />
            )}
            {/* {isEventDrawer && (
                <EventDrawer
                    eventType={eventType.type}
                    show={true}
                    modelId={contactId}
                    eventInfo={eventType.eventInfo}
                    viewMode="create"
                    allDay={allDay}
                    dateSelected={getMoment(defaultEventDate)}
                    onClose={() => {
                        setIsEventDrawer(false);
                        setEventType();
                        setDefaultEventDate();
                        setAllDay(false);
                    }}
                    afterUpdate={() => {
                        fetchEvents();
                    }}
                    afterRemove={() => {
                        setIsEventDrawer(false);
                        fetchEvents();
                        setDefaultEventDate();
                        setAllDay(false);
                    }}
                />
            )} */}
            {errorModal && (
                <StyledModal
                    open
                    width={480}
                    title="Error on drag"
                    footer={null}
                    closable
                    onCancel={() => setErrorModal('')}
                >
                    <div className="multi-event-modal-container">
                        <p>{errorModal}</p>
                    </div>
                </StyledModal>
            )}
            {modelDetailsDrawerID && (
                <ModelDrawer modelID={modelDetailsDrawerID} onClose={() => setModelDetailsDrawerID(null)} />
            )}
        </CalendarWrapper>
    );
};

export default ModelCalendar;
